import { useEffect, useState } from 'react';
import { Range } from '../ui/Range';

export const DecisionRow = ({ formularId, tableId, row, isSelect, option, elementType }) => {
	const fieldId = row.FELD['@attributes'].id;
	const rowName = row['@attributes'].name;

	const options = option?.OPTION
		? Array.isArray(option.OPTION)
			? option.OPTION
			: [option.OPTION]
		: [];

	const [localValue, setLocalValue] = useState('');

	useEffect(() => {
		if (row.FELD._value === '0') {
			setLocalValue('');
		} else {
			setLocalValue(formatValue(row.FELD._value));
		}

	}, [row.FELD._value]);

	const formatValue = (value) => {
		console.log('start formatValue')
		console.log(`value: ${value}`)
		if (isNaN(value) || !value) return;

		return new Intl.NumberFormat('de-DE', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2
		}).format(value);
	}

	const removeExtraCommas = (str) => {
		const indexOfComma = str.indexOf(',')

		if (indexOfComma === -1) {
			return str;
		}

		const beforeComma = str.slice(0, indexOfComma + 1);
		const afterComma = str.replaceAll(',', '').slice(indexOfComma);
		
		return beforeComma + afterComma;
	}

	const handleInputChange = (e) => {
		let raw = e.target.value;
		console.log(e.nativeEvent.data);
		console.log(e)
		console.log(raw)
		console.log(localValue)
		if (localValue.includes(',') && e.nativeEvent.data === ',') {
			console.log('return')
			return;
		}
		const newValue = raw.replace(/[^\d,]/g, "");
		console.log('before extra commas')
		console.log(newValue)
		setLocalValue(removeExtraCommas(newValue));
		console.log('after extra commas')
		console.log(removeExtraCommas(newValue))
	};

	const handleInputBlur = (e) => {
		console.log('start handleInputBlur')
		const value = e.target.value.replace(',', '.');
		console.log(`value: ${value}`)
		const newValue = formatValue(value);
		console.log(`new value: ${newValue}`)
		setLocalValue(newValue);
	}

	const handleOnFocus = (e) => {
		const value = e.target.value.replaceAll('.', '');
		setLocalValue(value);
	}

	// const handleRangeChange = (e) => {
	// 	const newValue = e.target.value;
	// 	setLocalValue(newValue);
	// }

	const inputElement = (
		<input
			type="text"
			inputMode="decimal"
			name={`tx_stzplanspieloffice_decision[decision][${formularId}][${tableId}][${fieldId}]`}
			value={localValue}
			onChange={handleInputChange}
			onBlur={handleInputBlur}
			onFocus={handleOnFocus}
		/>
	);

	const selectElement = (
		<select
			name={`tx_stzplanspieloffice_decision[decision][${formularId}][${tableId}][${fieldId}]`}
			defaultValue={row.FELD._value}
		>
			<option value="no_choice">Bitte auswählen</option>
			{options.map(opt => (
				<option
					key={opt['@attributes'].id}
					value={opt['@attributes'].id}
				>
					{opt['@attributes'].name}
				</option>
			))}
		</select>
	);

	console.log(`initial value for range element: ${localValue}`)
	const rangeElement = (
		<Range 
			name={`tx_stzplanspieloffice_decision[decision][${formularId}][${tableId}][${fieldId}]`}
			initialValue={localValue}
		/>
	)

	const elementsMap = {
		'input': inputElement,
		'select': selectElement,
		'range': rangeElement,
	};
	return (
		<div className="decision-row">
			<label><dfn>{rowName}</dfn></label>
			{elementsMap[elementType]}
		</div>
	);
};
